import { useEffect, useState } from "react";
import api from "../api/client";
import { History, CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function LoginHistory() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failedOnly, setFailedOnly] = useState(false);

  useEffect(() => {
    api.get("/admins/login-history", { params: { days: 30 } })
      .then((r) => setEvents(r.data.events || []))
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, []);

  const shown = failedOnly ? events.filter((e) => !e.success) : events;
  const failedCount = events.filter((e) => !e.success).length;

  return (
    <section className="border border-gray-300 bg-white rounded-sm p-4" data-testid="login-history-section">
      <div className="flex items-center gap-2 mb-1 flex-wrap">
        <History className="w-4 h-4 text-[#002FA7]" />
        <h4 className="text-sm font-black tracking-tight">Sign-in history (last 30 days)</h4>
        <label className="ml-auto inline-flex items-center gap-1.5 text-xs text-gray-600 cursor-pointer">
          <input type="checkbox" checked={failedOnly} onChange={(e) => setFailedOnly(e.target.checked)} data-testid="login-history-failed-only" />
          Failed only ({failedCount})
        </label>
      </div>
      <p className="text-xs text-gray-500 mb-2">Every administrator sign-in attempt with device and time. Kept for 90 days.</p>
      {loading ? (
        <div className="py-3 flex items-center gap-2 text-gray-500 text-sm"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
      ) : shown.length === 0 ? (
        <p className="text-sm text-gray-500 py-2" data-testid="login-history-empty">No sign-in events recorded yet.</p>
      ) : (
        <div className="max-h-72 overflow-y-auto -mx-4 px-4">
          <table className="w-full text-xs" data-testid="login-history-table">
            <thead className="text-left text-[10px] uppercase tracking-widest text-gray-500 sticky top-0 bg-white">
              <tr>
                <th className="py-1.5 pr-2">When</th>
                <th className="py-1.5 pr-2">Administrator</th>
                <th className="py-1.5 pr-2">Device</th>
                <th className="py-1.5 pr-2">IP</th>
                <th className="py-1.5">Result</th>
              </tr>
            </thead>
            <tbody>
              {shown.map((e) => (
                <tr key={e.id} className="border-t border-gray-100" data-testid={`login-event-${e.id}`}>
                  <td className="py-1.5 pr-2 whitespace-nowrap font-mono">{new Date(e.created_at).toLocaleString("en-AU", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</td>
                  <td className="py-1.5 pr-2">
                    <div className="font-semibold">{e.name || "—"}</div>
                    <div className="text-gray-500 font-mono">{e.email}</div>
                  </td>
                  <td className="py-1.5 pr-2">{e.device_label}</td>
                  <td className="py-1.5 pr-2 font-mono text-gray-500">{e.ip || "—"}</td>
                  <td className="py-1.5">
                    {e.success ? (
                      <span className="inline-flex items-center gap-1 text-green-700 font-bold"><CheckCircle2 className="w-3 h-3" /> OK</span>
                    ) : (
                      <span className="inline-flex items-center gap-1 text-red-700 font-bold"><XCircle className="w-3 h-3" /> Failed</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
